export default __webpack_public_path__ + "static/media/carolinaPanthersVideo-2x.03a36bb7.jpg";